var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chartContainer",staticClass:"p-4",attrs:{"id":"chartContainer"}},[_c('h6',[_vm._v("Top Words Used in Meeting")]),_c('svg',{staticStyle:{"overflow":"visible!important"},attrs:{"id":_vm.ID,"width":_vm.svgWidth,"height":_vm.svgHeight}})])
}
var staticRenderFns = []

export { render, staticRenderFns }